module.exports = __webpack_public_path__ + "static/media/TrueNorth_default_thumb.5a2cf09f.png";